import { pipe, prop } from 'ramda';

export const docViewSelector = (state) => state.docView;

export const isOpen = pipe(docViewSelector, prop('isModalOpen'));
